import { render, staticRenderFns } from "./search.vue.html?vue&type=template&id=46796fbe&scoped=true"
import script from "./search.controller.ts?vue&type=script&lang=js&external"
export * from "./search.controller.ts?vue&type=script&lang=js&external"
import style0 from "./search.vue.html?vue&type=style&index=0&id=46796fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46796fbe",
  null
  
)

export default component.exports